import React, { useRef, useState, useLayoutEffect, useCallback } from "react";
import "./TruncatedTitle.css";

const TruncatedTitle = ({ children, className = "", ...rest }) => {
  const textRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  const checkTruncation = useCallback(() => {
    const el = textRef.current;
    if (!el) return;
    setIsTruncated(el.scrollHeight > el.clientHeight + 1);
  }, []);

  useLayoutEffect(() => {
    checkTruncation();
    window.addEventListener("resize", checkTruncation);
    return () => window.removeEventListener("resize", checkTruncation);
  }, [children, checkTruncation]);

  return (
    <div
      className="truncated-title-wrapper"
      onMouseEnter={() => isTruncated && setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
      onFocus={() => isTruncated && setShowTooltip(true)}
      onBlur={() => setShowTooltip(false)}
    >
      <div
        ref={textRef}
        className={className}
        title={isTruncated ? undefined : rest.title}
        {...rest}
      >
        {children}
      </div>
      {isTruncated && showTooltip && (
        <div className="truncated-title-tooltip" role="tooltip">
          {children}
        </div>
      )}
    </div>
  );
};

export default TruncatedTitle;
